import Phosphor from "./PhosphorIcon";

export default Phosphor;
